module.exports = __webpack_public_path__ + "static/media/4.5aa1b46b.jpg";